
if(window.innerWidth >= 992) showActiveLink();

function showActiveLink() {
    const getId = (link) => link.getAttribute("href").replace('#', '');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting){
                document.querySelectorAll('.--link').forEach(link => {
                    link.classList.toggle('--active', getId(link) === entry.target.id);
                });
            }
            
        }), {
            
            threshold: 0.75,
        }
    });

    document.querySelectorAll('section').forEach(section => {
        observer.observe(section)
    });

    document.querySelector('.nav__list').addEventListener('click', (event) => {
        if(event.target.classList.contains('--link')){
            event.preventDefault();
        }
        window.scrollTo({
            top: document.getElementById(getId(event.target)).offsetTop,        
            behavior: 'smooth',
        })
    });
}



showMore();
function showMore() {	  
	const btnAdds = document.querySelectorAll('.--btn-add');
	btnAdds.forEach(btnAdd=> {
		btnAdd.addEventListener('click', function(e)  {
			this.parentElement.classList.remove('--hide-content');			
			btnAdd.remove();
		})
	})
}

if(document.querySelectorAll('.accordion')){accordion()}
function accordion() {
	const accordions = document.querySelectorAll('.accordion__trigger');
	accordions.forEach(accordion => {
		accordion.addEventListener('click', (e) => {
			const self = e.currentTarget;
			const parent = self.parentElement;
			const content = parent.querySelector('.accordion__content');
			parent.classList.toggle('open');
			
			if (parent.classList.contains('open')) {
				accordion.setAttribute('aria-expanded', true);
				content.setAttribute('aria-hidden', false);
				
			} else {
				accordion.setAttribute('aria-expanded', false);
				content.setAttribute('aria-hidden', true);
				
			}
		});			
	});		
	
}

if (window.innerWidth < 992) {
	document.querySelectorAll('.tultip').forEach(tultip => {
		tultip.addEventListener('click', (e) => {
			e.currentTarget.classList.toggle('tultip--active')
		})
	});
}


scrollSmooth();
function scrollSmooth() {
  const links = document.querySelectorAll('.--nav__link');
  for (let link of links) {
    link.addEventListener('click', function (e) {
      e.preventDefault()
      
      const blockID = link.getAttribute('href').substr(1)
      
      document.getElementById(blockID).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    })
  } 
}

function removeClass() {
  let menuLinkActive = document.querySelector('.menu__link.--active');

  if(menuLinkActive) {
    menuLinkActive.classList.remove('--active');
  }
}


if(document.querySelector('.buy__param-structure')){
  document.querySelector('.buy__param-structure').addEventListener('click', (e) => {
    document.querySelector('.buy__param-structure').classList.toggle('buy__param-structure--active')
  
  })
}


if(document.querySelector('.goods-card__slide')){
  changeIMG()
}
function changeIMG() {
  const image=['./img/products/3.jpg','./img/products/5.jpg','./img/products/7.jpg']
  

  btnadd('.goods-card__color-brown', image[0]);
  btnadd('.goods-card__color-purpure', image[1]);
  btnadd('.goods-card__color-orange', image[2]); 
  btnadd('.goods-card__color-red', image[0]);
  btnadd('.goods-card__color-dark', image[1]);
  btnadd('.goods-card__color-gray', image[2]); 
  function btnadd(btn, way) {
    if(document.querySelector(btn)){
      document.querySelector(btn).addEventListener("click", () => {
        document.querySelector('.goods-card__img>img').src= way;
      })
    }
  }
    

  slider();
  function slider() {
    const slides = document.querySelectorAll('.goods-card__slide');
    for(let index = 0; index < slides.length; index++) {
      let slide = slides[index];   
      slide.addEventListener("mouseover", (e) => {
        document.querySelector('.goods-card__img>img').src= e.currentTarget.src;
      })
    }   
  }
}

if(document.querySelector('.filter')) showFilter();

function showFilter() {
  const filter = document.querySelector('.filter');
  document.querySelector('.catalog__top-btn').addEventListener('click', () => {
    filter.classList.add('filter--active');
    document.body.classList.add('lock');
  })
  document.querySelector('.filter__top-close').addEventListener('click', () => {
    filter.classList.remove('filter--active')
    document.body.classList.remove('lock')
  })
  document.querySelector('.filter__bottom-btn-on').addEventListener('click', () => {
    filter.classList.remove('filter--active')
    document.body.classList.remove('lock')
  })
}



showBurger();
function showBurger() {
  const burger = document.querySelector('.nav__burger');
  const menu = document.querySelector('.nav__menu');

  burger.addEventListener('click', () =>  {      
    menu.classList.toggle('nav__menu--active');
    burger.classList.toggle('nav__burger--active');
    document.body.classList.toggle('lock');      
  });
  document.querySelectorAll('.nav__list-link').forEach(item =>{
    item.addEventListener('click', () =>{
 
    burger.classList.remove('nav__burger--active');
    menu.classList.remove('nav__menu--active');
    document.body.classList.remove('lock');  
    });
  })
};